
var DateTimeOffsetHelper = {
    getCurrentDatetimeWithOffset: () => {
        var now = new Date(),
            tzo = -now.getTimezoneOffset(),
            dif = tzo >= 0 ? '+' : '-',
            pad = function (num: number) {
                return (num < 10 ? '0' : '') + num;
            };
        return now.getFullYear()
            + '-' + pad(now.getMonth() + 1)
            + '-' + pad(now.getDate())
            + 'T' + pad(now.getHours())
            + ':' + pad(now.getMinutes())
            + ':' + pad(now.getSeconds())
            + '.' + (now.getMilliseconds() / 1000).toFixed(3).slice(2, 5)
            + dif + pad(Math.floor(Math.abs(tzo) / 60))
            + ':' + pad(Math.abs(tzo) % 60);
    }
}

export default DateTimeOffsetHelper;